import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, OnInit, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsVideoComponent, I18nModule, RoutingModule } from '@spartacus/core';
import { SpinnerModule, VideoComponent } from '@spartacus/storefront';

@Component({
  selector: 'custom-video',
  templateUrl: './video.component.html',
  styleUrl: './video.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, SpinnerModule, RouterModule, I18nModule],
})
export class CustomVideoComponent extends VideoComponent implements OnInit {
  @Input()
  data?: CmsVideoComponent = undefined;

  ngOnInit(): void {
    if (this.data) {
      this.styleClasses = this.data?.styleClasses;
      this.setMedia(this.data);
      this.setControls(this.data);
      this.setRouting(this.data);
    }
  }
}
